import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getCountries, postActivity } from "../../redux/actions.js";
import style from "./create.module.css";
import { Link, useHistory  } from "react-router-dom";
import validate from "./validators.jsx";
//import Loading from "../../components/Loading/Loading.jsx";

export default function Create() {
  const dispatch = useDispatch();
  const history = useHistory();
  const countries = useSelector((state) => state.countries);
  const [errors, setErrors] = useState({});

  const [input, setInput] = useState({
    name: "",
    difficulty: 1,
    duration: "",
    season: "",
    countries: [],
  });

  function handleChange(e) {
    setInput({
      ...input,
      [e.target.name]: e.target.value,
    });
    setErrors(
      validate({
        ...input,
        [e.target.name]: e.target.value,
      })
    );
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (
      !input.name ||
      !input.difficulty ||
      !input.duration ||
      !input.season ||
      !input.countries
    ) {
      console.log("El input", input);
      return alert("Complete all required fields");
    }
    postActivity(input);
    alert("Activity created");
    console.log(input);
    setInput({
      name: "",
      difficulty: 1,
      duration: "",
      season: "",
      countries: [],
    });
    history.push('/home')
  }

  function handleCheck(e) {
    console.log(e.target.checked);

    setInput({
      ...input,
      season: e.target.value,
    });
  }

  function handleSelect(e) {
    if (input.countries.includes(e.target.value)) {
      alert("The activity already has that country");
    } else {
      setInput({
        ...input,
        countries: [...input.countries, e.target.value],
      });
    }
  }

  function handleDelete(el) {
    setInput({
      ...input,
      countries: input.countries.filter((c) => c !== el),
    });
  }

  useEffect(() => {
    dispatch(getCountries());
  }, [dispatch]);

  return (
    <div className={style.containerCreate}>
      <div className={style.formTotal}>
        <Link to="/home" >
          <button className={style.backButton}>Back</button>
        </Link>
        <div>
              {/* <h2 className={style.title}>CREATE ACTIVITY</h2> */}
            </div>
        <div className={style.formulario}>
          <form onSubmit={(e) => handleSubmit(e)}>
            
            <div className={style.sInput}>
              <label className={style.name}>Name: </label>
              <input
                type="text"
                value={input.name}
                name="name"
                onChange={(e) => handleChange(e)}
              />
              {errors.name && <p className={style.error}>{errors.name}</p>}
            </div>
            <div className={style.sInput}>
              <label>Difficulty: </label>
              <input
                type="range"
                value={input.difficulty}
                min="1"
                max="5"
                name="difficulty"
                onChange={(e) => handleChange(e)}
              />
              {errors.difficulty ? (
                <p className={style.error}>{errors.difficulty}</p>
              ) : (
                <p className={style.data}>{input.difficulty}</p>
              )}
            </div>
            <div className={style.sInput}>
              <label>Duration in hours: </label>
              <input
                type="number"
                value={input.duration}
                name="duration"
                min="1"
                max="24"
                onChange={(e) => handleChange(e)}
              />
              {errors.duration && (
                <p className={style.error}>{errors.duration}</p>
              )}
            </div>
            <div>
              <label className={style.sInputs}> Season:</label>
              <select onChange={(e) => handleCheck(e)}>
                <option value={" "}></option>
                <option value="summer">Summer</option>
                <option value="autum">Autum</option>
                <option value="winter">Winter</option>
                <option value="spring">Spring</option>
                
                
               
              
              </select>
              
              
              
             
             
            </div>
            <div></div>
            <div className={style.sInputS}>
              <label>Option country: </label>
              <select onChange={(e) => handleSelect(e)}>
                {countries.map((c) => (
                  <option key={c.name} name="countries" value={c.id}>
                    {c.name}
                  </option>
                ))}
              </select>

              {input.countries.map((el) => (
                <div key={el.toString()} className={style.type}>
                  <p>{el}</p>{" "}
                  <button type="button" onClick={() => handleDelete(el)}>
                    x
                  </button>
                </div>
              ))}
            </div>
            <div className={style.create}>
              <button type="submit">Create Activity</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
